import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.form`
  display: grid;
  width: 100%;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  grid-template-columns: repeat(2, 1fr);
`

export const ActionsRow = styled.div`
  padding-top: 19px;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`
